import React from 'react';
import { motion } from 'framer-motion';
import { Users, Shield, Clock } from 'lucide-react';

interface PersonnelStatsProps {
  stats: {
    total: number;
    active: number;
    departments: number;
    thisMonth: number;
  };
}

const PersonnelStats: React.FC<PersonnelStatsProps> = React.memo(({ stats }) => {
  return (
    <div className="mb-8 grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-4">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.3, delay: 0.1 }}
        className="rounded-xl border border-gray-200 bg-white p-6 shadow-sm"
      >
        <div className="flex items-center justify-between">
          <div>
            <p className="text-sm font-medium text-gray-600">Συνολικό Προσωπικό</p>
            <p className="text-2xl font-bold text-gray-900">{stats.total}</p>
          </div>
          <div className="rounded-lg bg-blue-50 p-3">
            <Users className="h-6 w-6 text-blue-600" />
          </div>
        </div>
      </motion.div>

      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.3, delay: 0.2 }}
        className="rounded-xl border border-gray-200 bg-white p-6 shadow-sm"
      >
        <div className="flex items-center justify-between">
          <div>
            <p className="text-sm font-medium text-gray-600">Ενεργοί</p>
            <p className="text-2xl font-bold text-green-600">{stats.active}</p>
          </div>
          <div className="rounded-lg bg-green-50 p-3">
            <Shield className="h-6 w-6 text-green-600" />
          </div>
        </div>
      </motion.div>

      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.3, delay: 0.3 }}
        className="rounded-xl border border-gray-200 bg-white p-6 shadow-sm"
      >
        <div className="flex items-center justify-between">
          <div>
            <p className="text-sm font-medium text-gray-600">Τμήματα</p>
            <p className="text-2xl font-bold text-gray-900">{stats.departments}</p>
          </div>
          <div className="rounded-lg bg-purple-50 p-3">
            <Users className="h-6 w-6 text-purple-600" />
          </div>
        </div>
      </motion.div>

      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.3, delay: 0.4 }}
        className="rounded-xl border border-blue-200 bg-gradient-to-br from-blue-50 to-blue-100 p-6 shadow-sm"
      >
        <div className="flex items-center justify-between">
          <div>
            <p className="text-sm font-medium text-blue-700">Νέοι Αυτόν τον Μήνα</p>
            <p className="text-2xl font-bold text-blue-800">{stats.thisMonth}</p>
          </div>
          <div className="rounded-lg bg-blue-200 p-3">
            <Clock className="h-6 w-6 text-blue-700" />
          </div>
        </div>
      </motion.div>
    </div>
  );
});

PersonnelStats.displayName = 'PersonnelStats';

export default PersonnelStats;
